import { api } from './client'

/** Приложенное фото для улучшателя: имя-ссылка в тексте («Image 1») и подпись. */
export interface EnhancePhotoRef {
	name: string
	label?: string
	/** Вид файла — от него улучшатель назначает роль в тексте (photo | video | audio | frame | character). */
	kind?: 'photo' | 'video' | 'audio' | 'frame' | 'character'
}

export async function enhancePrompt(
	text: string,
	modelId: string,
	// character — описание внешности персонажа для окна «Новый персонаж» (свой системник на сервере).
	type: 'image' | 'video' | 'character',
	// Владелец 04.09: улучшатель принимал id модели за сюжет и не знал о
	// приложенных фото — передаём человеческое имя нейросети и имена фото.
	extra?: { modelName?: string; photos?: EnhancePhotoRef[] },
): Promise<string> {
	const data = await api.request<{ prompt: string }>('/api/v1/prompts/enhance', {
		method: 'POST',
		body: {
			text,
			context: {
				modelId,
				type,
				modelName: extra?.modelName || '',
				photos: (extra?.photos || []).filter((p) => p.name).map((p) => ({ name: p.name, label: p.label || '', kind: p.kind || 'photo' })),
			},
		},
	})
	return data.prompt
}

export async function generatePromptIdea(
	modelId: string,
	type: 'image' | 'video',
): Promise<string> {
	const data = await api.request<{ prompt: string }>('/api/v1/prompts/generate', {
		method: 'POST',
		body: { context: { modelId, type } },
	})
	return data.prompt
}
